import { __values } from 'tslib';
import { useRef, useLayoutEffect } from 'react';
import { useDisclosure } from '../../Disclosure/useDisclosure.js';
import 'react/jsx-runtime';
import '../../Box/index.js';
import '@emotion/react';
import 'lodash.get';
import '@compono/ui-theme';
import 'deepmerge';
import '@emotion/is-prop-valid';
import { useLayoutScreenContext } from '../../LayoutScreen/LayoutScreen/LayoutScreenContext.js';
import '../../LayoutScreen/LayoutHeader/LayoutHeader.js';
import { useMainNavContext } from '../MainNavContext/index.js';

function childIsCurrent(itemsElem) {
    var e_1, _a;
    if (!itemsElem)
        return false;
    try {
        for (var _b = __values(Array.from(itemsElem.children)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var child = _c.value;
            if (child.hasAttribute("aria-current") ||
                child.hasAttribute("data-current")) {
                return true;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return false;
}
var fallbackContext = { sidebar: { collapseState: { isCollapsed: false } } };
var useMainNavMenu = function (_a) {
    var currentIsOpen = _a.currentIsOpen, defaultIsOpen = _a.defaultIsOpen, id = _a.id;
    var themeKey = useMainNavContext().themeKey;
    var sidebar = useLayoutScreenContext({ fallbackContext: fallbackContext }).sidebar;
    var isCollapsed = sidebar.collapseState.isCollapsed;
    var itemsRef = useRef(null);
    var disclosure = useDisclosure({
        id: id,
        defaultIsOpen: isCollapsed ? false : defaultIsOpen,
    });
    // close the menu if the sidebar is collapsed
    useLayoutEffect(function () {
        if (isCollapsed && disclosure.isOpen) {
            disclosure.setIsOpen(false);
        }
    }, [isCollapsed]);
    // open menu if it is current
    useLayoutEffect(function () {
        if ((isCollapsed ? false : currentIsOpen) &&
            childIsCurrent(itemsRef.current)) {
            disclosure.setIsOpen(true);
        }
    }, [isCollapsed]);
    return { disclosure: disclosure, itemsRef: itemsRef, themeKey: themeKey };
};

export { useMainNavMenu };
//# sourceMappingURL=useMainNavMenu.js.map
